const createRoutes = function ({ path, name, redirectTo404, divider = '-' }) {
  const toName = (value) => [name, value].join(divider);
  const Info = () => import('./Info.vue' /* webpackChunkName: "PfDodInfo" */);

  const result = {
    path,
    component: Info,
    redirect: { name: toName('info') },
    children: [
      {
        path: 'info',
        component: Info,
        name: toName('info'),
        beforeEnter: redirectTo404('hasApiModulePfdod'),
      },
    ],
  };

  return [result];
};

export { createRoutes };



// WEBPACK FOOTER //
// ./src/pages/pf-dod/index.js